<template>

<Draggable :style="panelStyle" class="panel" v-model="tree.panels" :class="{selected: isSelected}" @click.native.shift.prevent.stop="selectPanel(panel)" :options="{ animation: 350, group:parentName, xxxhandle: '.menu-icon'}" @end="afterDrag">
<!-- <div :style="panelStyle" class="panel" :class="{selected: isSelected}" @click.shift.prevent.stop="selectPanel(panel)"> -->
    <div v-if="isSelected" class="overlay-heading higher">
        {{panel.name}}
        <v-btn @click.stop="navigateUp" dark text icon style="margin-top:1px">
            <v-icon dark >keyboard_arrow_up</v-icon>
        </v-btn>
        <v-btn @click.stop="showDialog" dark text icon style="margin-top:1px">
            <v-icon dark >more_horiz</v-icon>
        </v-btn>
    </div>
    <div v-if="panel.placeholderText" v-text="this.placeholderText"></div>
    

    <LayoutPanel v-for="panel in tree.panels" :tree="getChildTree(panel)" :parent="tree" :key="panel.name"/>

    
    <PanelDialog :dialog="panelDialog" @save="saveField" />
<!-- </div> -->
</Draggable>

</template>

<script>
import DataHelpers from '../helpers/DataHelpers'
import PageHelpers from '../helpers/PageHelpers'
import PanelDialog from '../ui-elements/PanelDialog'
import Draggable from 'vuedraggable'


export default {
data() {
    return {
        panelDialog: {
            settings: {
                visible:false,
            },
            field: {},
        }
    
    }
},

components: {
    PanelDialog,
    Draggable,
},

props: {
    tree: Object,
},

computed: {
    panel() {
        return this.tree.panel
    },

    parentName() {
        if(this.panel && this.panel.parent)
            return this.panel.parent.name
        
        else
            return 'top'
    },
    isSelected() {
        if(!this.selectedPanel)
            return false 
        //console.log('here')
        return (this.panel.name == this.selectedPanel.name)
    },

    placeholderText() {
        if(this.panel.placeholderText)
            return Array(500).fill(this.panel.name).join(' ')
    },
    panelStyle() {
        let style = {
            'min-width': '100px',
            // 'border-color': '#BBDEFB',
            // 'border-width': '1px',
            // 'border-radius': '3px',
            // 'border-style': 'solid',
            padding: '0px',
            'display': 'flex',
            // 'flex-wrap': 'wrap',
            'flex-grow': '1',
            // 'margin-left': '-1px',
            'flex-direction': this.panel.hasColumns ? 'row' : 'column',
            'overflow-y': 'scroll',
            'position': 'relative',

        }
        if(this.panel.width)
            style.flexBasis = this.panel.width + '%'

        return style
    },

    selectedPanel() {
        return PageHelpers.getPageData('selected-panel')
    }
    
},

methods: {
    saveField() {

    },

    showDialog() {
        debugger
        this.panelDialog.field = this.panel
        this.panelDialog.settings.visible = true
    },
    navigateUp() {
        PageHelpers.setPageData('selected-panel', this.tree.parent)
    },
    getChildTree(panel) {
        // let newTree = {...panel}
        // newTree.parent = this.tree
        // newTree.rootPanel = this.tree.rootPanel
        // return newTree
        panel.parent = this.tree
        panel.rootPanel = this.tree.rootPanel
        return panel
    },
    selectPanel(panel) {
        
        document.getSelection().removeAllRanges()
        
        // delete this.tree.rootPanel.selectedPanel
        // this.$set(this.tree.rootPanel, 'selectedPanel', panel)
        PageHelpers.setPageData('selected-panel', panel)
    },
    afterDrag() {

    },

},

created() {
    if(!this.tree.parent)
        this.tree.rootPanel = this.panel

}
}
</script>

<style scoped>
.placeholder {
    color:#ddd;
}

.panel.selected {
    border: dashed 2px #888;
}

.overlay-heading {
    padding:0px 8px;background-color: rgba(0,0,0,0.7);position:absolute;height:40px;top:0;left:0;right:0;color:#eee;
}
.higher {
    z-index: 100;
}
   
</style>




// WEBPACK FOOTER //
// LayoutPanel.vue?18ab2fdd